/// <reference path="../Init.ts"/>

namespace RS.ExternalHelp
{
    class CopyrightPlugin extends Plugin
    {
        private readonly _showSecondary: boolean;

        public constructor(page: IPage)
        {
            super(page);

            this._showSecondary = page.languageCode !== "en";
        }

        public onPageLoaded(page: IPage)
        {
            if (!this._showSecondary)
            {
                const secondary = document.getElementById("rs-copyright-en");
                if (secondary)
                {
                    secondary.style.display = "none";
                    hideLocalisation(secondary);
                }
            }
        }
    }

    pluginRegistry.register(CopyrightPlugin);
}